import React, { useMemo } from "react";
import { PAYMENT_CONFIG } from "../../paymentConstants";
import BinIcon from "../../../../components/icon/Icon";
import { PaymentMethodLogoStyled } from "./styled/PaymentMethodLogoStyled";

interface IPaymentMethodLogoProp {
    paymentKey?: string;
    size?: number | string;
}

const PaymentMethodLogo = (props: IPaymentMethodLogoProp) => {
    const { paymentKey = '', size = 32 } = props;

    const iconName: string = useMemo(() => PAYMENT_CONFIG[paymentKey]?.icon, [paymentKey]);

    return <PaymentMethodLogoStyled fontSize={size}>
        <BinIcon name={iconName || 'IcPaymentMethod'}/>
    </PaymentMethodLogoStyled>
}

export default PaymentMethodLogo;
